//Interfaces para la request comisiones
export interface ComisionesRequest {
  cutDate: Date;
  cutSelection: number;
  producerNumbers: number;
}

export interface ComisionesResponse {
  paystub: PayStubResponse[];
  commissionDetails: CommissionDetailsResponse[];
  collectionCommission: CollectionCommissionResponse[];
}

//Interfaces para la respuesta comisiones
export interface PayStubResponse {
  producerCode: number;
  producerName: string;
  producerType: string;
  address: string;
  emailAddress: string;
  phoneNumber: string;
  licenceNumber: string;
  licenceExpiration: string;
  bank: string;
  accountType: string;
  accountNumber: string;
  paymentType: string;
  currencyCode: number;
  currency: string;
  cutDate: string;
  groupingCode: number;
  grouping: string;
  ammount: number;
}

export interface CommissionDetailsResponse {
  producerName: string;
  slob: number;
  policyNumber: string;
  invoiceNumber: number;
  netPremium: number;
  commission: number;
  commissionRate: number;
  wDate: string;
  rCurrency: number;
  coverageGroupDescription: string;
  coinsurancePercent: number;
  commissionCredito: number;
  currency: number;
  clientName: string;
  currencyName: string;
  slobDescription: string;
  dateFrom: string;
  dateTo: string;
  document: string;
}

export interface CollectionCommissionResponse {
  producerName: string;
  slob: number;
  policyNumber: string;
  invoiceNumber: number;
  coverageValue: number;
  coverageValuePart: number;
  comision: number;
  wDate: string;
  gCovDescription: string;
  commissionPercentage: number;
  clientName: string;
  dateFrom: string;
  dateTo: string;
  document: string;
}

export interface ComisionesDocumentType {
  documentTypeId: TipoDocumentoComisiones;
  documentTypeName: string;
}

export enum TipoDocumentoComisiones {
  VOLANTE_PAGO = 1,
  DETALLES = 2,
  DETALLES_POR_COBRO = 3,
}
